import React from 'react';
import { Col, Form, Row } from 'react-bootstrap';
import { OrganismSelectContact } from '..';
import { Button, Text, Img, Icon, DatePicker } from '../../Atoms';
import { Upload, Input } from '../../Molecules';
import fileImage from '../../assets/img/file.png';
import nature from '../../Json/Nature.json';
import { pink } from '../../Config/Config';
import { ModalInfoDocument } from '../../Modals';

const EMPTY_OPTION_BENEFICIARY = {
  value: '',
  text: '-- Bénéficiaire du soin --',
  empty: true
};

const EMPTY_OPTION_NATURE = {
  value: '',
  text: '-- Nature de la prestation --',
  empty: true
};

function OrganismFormDocument(props) {
  const [show, setShow] = React.useState(false);

  function renderStep2() {
    return (
      <div>
        <Text
          text={props.type.name + ' - ' + props.category.name}
          type="h8"
          className="header-description-document-step2"
        />
        <Form.Control
          className="default-input input-decription-document input-description-medicine"
          style={{ minHeight: 135 }}
          placeholder="Laissez-nous un message qui décrit votre besoin (facultatif)"
          as={'textarea'}
          onChange={(e) => props.onChange(e)}
          value={props.description}
        />
        <div className="container-description-spvie-medicine">
          <Text
            text="Vous pouvez également nous transmettre ces documents par voie postale à l'adresse ci-dessous :"
            className={'description-condition-send-document  doc-mar-bot'}
          />
          <div className="description-spvie-medicine">
            <Text
              text="SPVIE Remboursements"
              className={'description-condition-send-document  doc-mar-bot'}
            />
            <Text
              text="CGRM TSA 91005"
              className={'description-condition-send-document doc-mar-bot'}
            />
            <Text
              text="59952 Dunkerque"
              className={'description-condition-send-document doc-mar-bot'}
            />
          </div>
        </div>
        <div className="container-btn-send-doc">
          <Button
            text="Envoyer"
            className="btn-send-doc btn-send-doc-medicine"
            onClick={() => props.onSubmit()}
          />
        </div>
        {props.sendDocumentIsLoading ? (
          <Text
            type="h6"
            style={{ color: 'black' }}
            text="Envoi des documents en cours ... Veuillez ne pas quitter la page."
          />
        ) : null}
        {props.errorsUpload?.length > 0 ? (
          <div className="pt-20">
            {props.errorsUpload?.map((item, i) => (
              <div key={i} className="upload-error-message pb-5">
                {item}
              </div>
            ))}
          </div>
        ) : null}
      </div>
    );
  }
  if (
    props.type.name?.toLowerCase() === 'facture' &&
    props.category.name?.toLowerCase() === 'médecine douce'
  ) {
    return (
      <div>
        {props.stepMedicine === 1 && (
          <div>
            <Row className="row-document">
              <Col xs={6} className="col-document">
                <Text
                  text="Bénéficiaire du soin"
                  className="label-input-document"
                />
                <div
                  className={`default-input ${props.errorsMedecine?.includes('beneficiaire')
                      ? 'input-document-error'
                      : ''
                    }`}
                  style={{ overflow: 'hidden' }}
                >
                  <select
                    className={'input-document input-document-select-ios'}
                    style={{ width: '100%', outline: 'none', border: 'none' }}
                    onChange={(e) =>
                      props.onChangeMedicine(e.target.value, 'benefitaire')
                    }
                    value={props.medicine.benefitaire}
                  >
                    {[EMPTY_OPTION_BENEFICIARY, ...props.beneficiaries].map(
                      (item, index) => (
                        <option
                          key={index}
                          value={item.value}
                          {...(item.empty
                            ? { disabled: true, selected: true }
                            : {})}
                        >
                          {item.text}
                        </option>
                      )
                    )}
                  </select>
                </div>
                {props.errorsMedecine?.includes('beneficiaire') ? (
                  <Text
                    className="default-error-msg"
                    text="Ce champ est requis"
                  />
                ) : null}
              </Col>
              <Col xs={6} className="col-document">
                <Text text="Date du soin" className="label-input-document" />
                <DatePicker
                  placeholder="JJ/MM/AAAA"
                  renderIcon={false}
                  containerClassName="full-container"
                  className={`full-container ${props.errorsMedecine.includes('date')
                      ? 'input-document-error'
                      : ''
                    }`}
                  onChange={(e) => props.onChangeMedicine(e, 'date')}
                  selected={props.medicine.date}
                />
                {props.errorsMedecine.includes('date') ? (
                  <Text
                    className="default-error-msg"
                    text="Ce champ est requis."
                  />
                ) : null}
              </Col>
              <Col xs={6} lg={12} className="col-document">
                <Text
                  text="Nature de la prestation"
                  className="label-input-document"
                />
                <div
                  className={`default-input ${props.errorsMedecine?.includes('nature')
                      ? 'input-document-error'
                      : ''
                    }`}
                  style={{ overflow: 'hidden' }}
                >
                  <select
                    className={'input-document input-document-select-ios'}
                    style={{ width: '100%', outline: 'none', border: 'none' }}
                    onChange={(e) =>
                      props.onChangeMedicine(e.target.value, 'nature')
                    }
                    value={props.medicine.nature}
                  >
                    {[EMPTY_OPTION_NATURE, ...nature.data].map(
                      (item, index) => (
                        <option
                          key={index}
                          value={item.value}
                          {...(item.empty
                            ? { disabled: true, selected: true }
                            : {})}
                        >
                          {item.text}
                        </option>
                      )
                    )}
                  </select>
                </div>
                {props.errorsMedecine?.includes('nature') ? (
                  <Text
                    className="default-error-msg"
                    text="Ce champ est requis"
                  />
                ) : null}
              </Col>
              <Col xs={6} className="col-document">
                <div className="container-spaced">
                  <Text
                    text="Code Adeli ou N° Siret"
                    className="label-input-document"
                  />
                  <Icon
                    icon="info"
                    size="14px"
                    className="icon-info-document"
                    onClick={() => setShow(true)}
                  />
                </div>
                <Input
                  type="number"
                  inputmode="numeric"
                  placeholder=""
                  className={
                    props.errorsMedecine?.includes('code')
                      ? 'input-document-error'
                      : 'input-document'
                  }
                  classNameInputContainer="full-container"
                  errorMsg={
                    props.errorsMedecine?.includes('code')
                      ? 'Ce champ est requis.'
                      : null
                  }
                  onChange={(e) =>
                    props.onChangeMedicine(e.target.value, 'code')
                  }
                  value={props.medicine.code}
                />
              </Col>
              <Col xs={12} lg={6}>
                <div className="container-amount-document">
                  <Text
                    text="Montant dépensé :"
                    className="label-input-document"
                  />
                  <Input
                    value={props.medicine.amount}
                    onChange={(e) =>
                      props.onChangeMedicine(e.target.value, 'amount')
                    }
                    inputmode="numeric"
                    className={`input-amount-doc ${props.errorsMedecine.includes('amount')
                        ? 'input-amount-doc-error'
                        : ''
                      }`}
                    classNameContainer="container-input-amount-doc"
                    placeholder=""
                  />
                  <Text text="€" className="label-input-document" />
                </div>
              </Col>
            </Row>
            <Upload
              handleFileChange={props.selectFile}
              id="document"
              contentClassName={'input-file-document'}
              manuallyHandleFiles={true}
              files={props.files}
              isUploadValid={!props.errorsMedecine.includes('files')}
              errorMsg={
                props.errorsMedecine.includes('files')
                  ? 'Veuillez insérer un fichier'
                  : ''
              }
              style={{ height: '1px' }}
              uploadContent={
                window.innerWidth > 768 ? (
                  <div className="content-input-file-document">
                    <Img src={fileImage} className="img-file-upload" />
                    <div>
                      Glissez et déposez vos fichiers ici, ou{' '}
                      <span>téléchargez-les</span> depuis votre ordinateur
                    </div>
                  </div>
                ) : null
              }
            />
            {!props.showNewMutual && (
              <div className="container-btn-send-doc container-btn-send-doc-medicine ">
                <Button
                  text="Ajouter une autre mutuelle"
                  className="btn-send-doc btn-add-mutual"
                  onClick={() => props.openNewMutual()}
                />
              </div>
            )}
            {props.showNewMutual && (
              <div>
                <hr />
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'flex-end',
                    paddingRight: 10
                  }}
                >
                  <span
                    onClick={props.closeNewMutual}
                    style={{
                      paddingLeft: 20,
                      paddingRight: 10,
                      cursor: 'pointer'
                    }}
                  >
                    ✗
                  </span>
                </div>
                <div className="container-mutual-amount-document">
                  <Text
                    text="Montant remboursé par l’autre mutuelle :"
                    className="label-input-document"
                  />
                  <Input
                    value={props.mutual.amount}
                    inputmode="numeric"
                    onChange={(e) =>
                      props.onChangeMutual(e.target.value, 'amount')
                    }
                    className={`input-amount-doc ${props.errorsMedecine.includes('amount_other')
                        ? 'input-amount-doc-error'
                        : ''
                      }`}
                    classNameContainer="container-input-amount-doc"
                    placeholder=""
                  />
                  <Text text="€" className="label-input-document" />
                </div>
                <Text
                  text="Merci de bien vouloir nous transmettre le justificatif de votre autre mutuelle"
                  className="label-input-document"
                />
                <Upload
                  handleFileChange={(e) => props.onChangeMutual(e, 'file')}
                  id="mutual"
                  contentClassName={'input-file-document'}
                  manuallyHandleFiles={true}
                  files={props.mutual.file}
                  isUploadValid={!props.errorsMedecine.includes('files_other')}
                  errorMsg={
                    props.errorsMedecine.includes('files_other')
                      ? 'Veuillez insérer un fichier'
                      : ''
                  }
                  style={{ height: '1px' }}
                  uploadContent={
                    window.innerWidth > 768 ? (
                      <div className="content-input-file-document">
                        <Img src={fileImage} className="img-file-upload" />
                        <div>
                          Glissez et déposez vos fichiers ici, ou{' '}
                          <span>téléchargez-les</span> depuis votre ordinateur
                        </div>
                      </div>
                    ) : null
                  }
                />
              </div>
            )}
            <div className="container-btn-send-doc container-btn-send-doc-medicine">
              <Button
                text="Suivant"
                className="btn-send-doc"
                onClick={() => props.medicineStep(2)}
              />
            </div>
          </div>
        )}
        {props.stepMedicine == 2 && renderStep2()}
        <ModalInfoDocument show={show} onHide={() => setShow(false)} />
      </div>
    );
  }
  return (
    <div style={{ paddingBottom: '30px' }}>
      <Upload
        handleFileChange={props.selectFile}
        errorMsg="Attention : merci de bien vouloir nous joindre votre document."
        isUploadValid={props.isUploadValid}
      />
      <Form.Control
        className="default-input input-decription-document"
        style={{ minHeight: 135 }}
        placeholder="Laissez-nous un message qui décrit votre besoin (facultatif)"
        as={'textarea'}
        onChange={(e) => props.onChange(e)}
        value={props.description}
      />
      {!props.isDescriptionValid && (
        <Text
          className="mt-10 upload-error-message"
          text="Attention : merci de bien vouloir joindre un message à votre envoi."
        />
      )}
      {props.errorsUpload?.length > 0 ? (
        <div className="pt-20">
          {props.errorsUpload?.map((item, i) => (
            <div key={i} className="upload-error-message pb-5">
              {item}
            </div>
          ))}
        </div>
      ) : null}
      <div className="container-btn-send-doc">
        <Button
          disabled={
            !props.isUploadValid ||
            !props.isDescriptionValid ||
            props.sendDocumentIsLoading
          }
          text="Envoyer"
          className="btn-send-doc"
          onClick={() => props.onSubmit()}
        />
      </div>
    </div>
  );
}
OrganismFormDocument.defaultProps = {
  type: '',
  category: '',
  onSubmit: null,
  onChange: null,
  description: null,
  selectFile: null,
  selectBenef: null,
  medicineStep: null,
  openNewMutual: null
};
export default OrganismFormDocument;
